import React, { Component } from 'react';
import GoogleMapReact from 'google-map-react';
import pin from '../../images/pin.svg';
import styled from 'styled-components';

const Marker = () => <div><PinImage src={pin} /></div>;

class MyGoogleMap extends Component {
  constructor(props) {
    super(props);
  }
  
  static defaultProps = {
    zoom: 15
  };

  render() {
    return (
      // Important! Always set the container height explicitly
      <div style={{ height: '400px', width: '100%' }}>
        <GoogleMapReact
          bootstrapURLKeys={{ key: 'AIzaSyDpM49Lzmf_arBeDC7J7zDBygxPstEnv3U' }}
          defaultCenter={this.props.center}
          defaultZoom={this.props.zoom}
        >
          <Marker
            lat={this.props.center.lat}
            lng={this.props.center.lng}
          />
        </GoogleMapReact>
      </div>
    );
  }
}

const PinImage = styled.img`
   position: relative;
   top: -30px;
   left: -15px;
   width: 30px;
`


export default MyGoogleMap;